import { useEffect } from "react";
import useDarkModeEnabled from "./useDarkModeEnabled";

export default useColorSchemePreference;

const DARK_MODE_CLASS = "pf-v6-theme-dark";
function useColorSchemePreference() {
  const enabled = useDarkModeEnabled();
  useEffect(() => {
    if (enabled) {
      document.documentElement.classList.add(DARK_MODE_CLASS);
    } else {
      document.documentElement.classList.remove(DARK_MODE_CLASS);
    }
  }, [enabled]);
}
